<template>
  <div class="order__price-block" :class="cart ? 'active' : ''" v-if="!cart || cart.modifiable === true">
    <div class="order__button-minus" @click="minus" v-if="!minusActionLoading">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 12L18 12" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
    <TheSpinner v-else/>
    <div class="order__price-new" @click="plus" v-if="showInCenterPrice"> {{  cart?.total? cart?.total : product.price }}</div>
    <div class="order__price-new" @click="plus" v-else> {{ cart.quantity }}</div>
    <div class="order__button-plus" @click="plus" v-if="!plusActionLoading">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 12H18M12 6V18" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
    <TheSpinner v-else/>

    <div itemprop="offers" itemscope itemtype="https://schema.org/Offer" style="display: none">
      <meta itemprop="priceCurrency" content="RUB">
      <meta itemprop="price" :content="product?.price">
      <link itemprop="availability" href="https://schema.org/InStock">
      <meta itemprop="priceValidUntil" content="2025-12-31">
    </div>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import TheSpinner from "@/components/TheSpinner.vue";

export default {
  name: 'TheProductPlusAndMinusBox',
  components: {TheSpinner},
  data() {
    return {
      plusActionLoading: false,
      minusActionLoading: false,
    }
  },
  props: {
    product: {
      type: Object,
      require: true,
    },
    showInCenterPrice: {
      type: Boolean,
      default: true
    },
    cart: {
      type: Object,
      default: null,
      require: false,
    }
  },
  computed: {
    ...mapState({
      'products': state => state.cart.products,
      'sipping' : state => state.shipping.shipping
    }),
  },
  methods:{
    ...mapActions({
      'add': 'cart/add',
      'update': 'cart/update',
    }),
    ...mapMutations({
      'setShowModal': 'shipping/setShowModal',
    }),
    minus(){
      this.minusActionLoading = true;
      this.update({
        cart_id: this.cart.cart_id,
        quantity: parseInt(this.cart.quantity) - 1
      }).finally(() => {
        this.minusActionLoading = false;
      })

      this.sendYandexEcommerceCartRemove()
    },
    async plus() {
      if(!this.sipping){
        this.setShowModal(true);
        this.$toast.open({
          message: 'Выберите способ получения заказа, чтобы добавить товар в корзину',
          type: 'default',
        });
        return;
      }
      this.plusActionLoading = true;
      if (this.cart) {
        await this.update({
          cart_id: this.cart.cart_id,
          quantity: parseInt(this.cart.quantity) + 1
        }).finally(() => {
          this.plusActionLoading = false;
        })
      } else {
        await  this.add({
          product_id: this.product.product_id
        }).finally(() => {
          this.plusActionLoading = false;
        })
      }

      this.sendYandexEcommerceCartAdd()

    },
    sendYandexEcommerceCartAdd() {
      window?.dataLayer?.push({
        "ecommerce": {
          "currencyCode": "RUB",
          "add": {
            "products": [
              {
                "id": this.product.product_id,
                "name": this.product.name,
                "price": parseInt(this.cart?.total? this.cart?.total : this.product.price) || 0,
                "quantity": 1,
                 brand: "Краснодарский парень",
                "list": "Catalog",
                "position": 1
              }
            ]
          }
        }
      });
    },
    sendYandexEcommerceCartRemove() {
      window?.dataLayer?.push({
        "ecommerce": {
          "currencyCode": "RUB",
          "remove": {
            "products": [
              {
                "id": this.product.product_id,
                "name": this.product.name,
                "price": parseInt(this.cart?.total? this.cart?.total : this.product.price) || 0,
                "quantity": 1,
                brand: "Краснодарский парень",
                "list": "Catalog",
                "position": 1
              }
            ]
          }
        }
      });
    }

  }
}
</script>

